/**
 * @generated SignedSource<<611b73538b285f62b577ee6ad8a13637>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Avatar_user$data = {
  readonly name: string;
  readonly " $fragmentType": "Avatar_user";
};
export type Avatar_user$key = {
  readonly " $data"?: Avatar_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Avatar_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e07540b34343e5eed9c4b098ed07b1b7";

export default node;
